import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import PartnerDataDatatable from './PartnerDataDatatable';
import PartnerDataModal from './PartnerDataModal';



const PartnerDataTab = (props) => {

    
    const [show , setShow]= useState(false);
    const [entityId, setEntityId ] = useState();
    const [recordId, setRecordId ] = useState();
   
    const handleCallback = (id) => {
          setRecordId(id);       
          setShow(true);   
    };
 

    useEffect(() => {
      setEntityId(props.entityId);
    }, [props.entityId])

    const modalCallback = (isShow) => {             
      setShow(isShow);   
      //setDataChanged(dataChanged) ;         
    }

//    useEffect( () => {
  //    console.log("BankAccountDatatable state.recordId: "+recordId);   
    //  console.log("showModal: "+show);   
   // }, [recordId,show]);
  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
          <PartnerDataDatatable
            
            parentCallback={handleCallback}
            entityId={entityId}
            entityName={props.entityName}                    
            modalShow={show}                    
          />
          <PartnerDataModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}
            entityId={entityId}
            entityName={props.entityName}        
          />
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} //current => !current
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default PartnerDataTab;